// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { Form, FormItem, Input, InputNumber, Radio, RadioGroup, RadioButton, Checkbox, CheckboxButton, CheckboxGroup, Option, OptionGroup,
  TableColumn, Row, Col, DatePicker, Cascader, Loading, TimeSelect, TimePicker, Button, Select, Carousel, CarouselItem, Pagination} from 'element-ui'
import 'babel-polyfill'
import axios from './http/http'
import qs from 'qs'
import router from './router'
import JsEncrypt from 'jsencrypt'// RSA加密
// import jscookie from 'js-cookie'
import Cookies from 'js-cookie'
import 'css/reset.css'
import 'css/index.styl'

Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Select)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Pagination)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Cascader)
Vue.use(Loading)
Vue.use(Row)
Vue.use(Col)

Vue.prototype.$http = axios
// axios.defaults.baseURL = 'http://192.168.0.63/CqepcXG/WebAPI/api'
// axios.defaults.baseURL = 'http://www.test.com/CqepcXG/WebAPI/api'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.prototype.$qs = qs
Vue.prototype.$Cookies = Cookies
Vue.prototype.$jsEncrypt = function (parms) {
  let encrypt = new JsEncrypt()
  encrypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCK4n2xrbtnRyBqMJ2iiDeDRdJ/F8EVmzcjSGy/vVNfEVahl6sQOjQXZTc8AEbiZdyLnP9QwX3ZkIsEGUz1VMaPUJeHLHQC5uVljRWR0ORt4oiU7mtN5ZsEl8gPQBzSbC7IpnXVRN1Mx7s/RlFsWZgkuZKbPjxcfgoA9zXyhmcHywIDAQAB');
  let data = encrypt.encrypt(parms)
  return data
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js